import React from 'react';
import './style.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fromResource } from 'store/selectors';
import dayjs from 'dayjs';
import { Modal, Translate } from 'components';
import { displayDisplayDigitalIdInfo } from 'store/actions';

const DigitalIDModal = ({ details, onHideDigitalIdInfo }) => {
  const imageSrc = `data:${details.Image.ImageContentType};base64,${details.Image.Image}`;

  return (
    <Modal
      mainTitle={Translate({ content: 'digitalId.title' })}
      isVisible
      className="tv-digitalID-modal__container"
      onClose={onHideDigitalIdInfo}
    >
      <div className="tv-digitalID-container">
        <div className="tv-digitalID-image-container">
          <img className="personal-image" src={imageSrc} alt="profile" />
          <img className="logo-image" src="/images/logo.png" alt="logo" />
        </div>
        <div className="tv-digitalID-detail-container">
          <h2>{`${details.FirstName} ${details.LastName}`}</h2>
          <h5>{details.PersonalIdentityNumber}</h5>
          <ul className="tv-digitalID-detail-container__skills">
            {details.Skills.sort((a, b) => a.SortOrder - b.SortOrder)
              .slice(0, 6)
              .map(skill => (
                <li key={`${skill.Skill}-${skill.CompetenceLevel}`}>
                  {skill.Skill} - {skill.CompetenceLevel}
                </li>
              ))}
          </ul>
          <h1 className="tv-digitalID-detail-container__tolk-ID">Tolk - ID</h1>
          <div className="tv-digitalID-detail-container__footer">
            <div className="tv-digitalID-detail-container__section">
              <div className="tv-digitalID-detail-container__section--title">
                {Translate({ content: 'digitalId.interpreterNumber' })} :
              </div>
              <p>{details.InterpreterNumber}</p>
            </div>
            <div className="tv-digitalID-detail-container__section">
              <div className="tv-digitalID-detail-container__section--title">
                {Translate({ content: 'digitalId.dateValidTo' })} :
              </div>
              <p>
                {dayjs(details.DateValidTo, 'M/D/YYYY h:mm:ss A').format(
                  'YYYY/MM/DD',
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

DigitalIDModal.propTypes = {
  details: PropTypes.shape({
    FirstName: PropTypes.string,
    LastName: PropTypes.string,
    PersonalIdentityNumber: PropTypes.string,
    Skills: PropTypes.arrayOf(
      PropTypes.shape({
        Skill: PropTypes.string,
        CompetenceLevel: PropTypes.string,
      }),
    ),
    InterpreterNumber: PropTypes.number,
    DateValidTo: PropTypes.string,
    Image: PropTypes.shape({
      ImageContentType: PropTypes.string,
      Image: PropTypes.string,
    }),
  }),
  onHideDigitalIdInfo: PropTypes.func,
};
DigitalIDModal.defaultProps = {
  details: {
    FirstName: '',
    LastName: '',
    PersonalIdentityNumber: '',
    Skills: [
      {
        Skill: '',
        CompetenceLevel: '',
      },
    ],
    InterpreterNumber: 0,
    DateValidTo: '',
    Image: {
      ImageContentType: '',
      Image: '',
    },
  },
  onHideDigitalIdInfo: () => {},
};

const mapDispatchToProps = dispatch => ({
  onHideDigitalIdInfo: () => {
    dispatch(displayDisplayDigitalIdInfo(false));
  },
});
const mapStateToProps = state => {
  const degitalIdDetails =
    fromResource.getDetail(state, 'getInterpreterIdentificationCard') || {};
  return {
    details: degitalIdDetails.DigitalIdentificationCard,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DigitalIDModal);
